import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@app/store";

/**
 * Mirrors the legacy `page/main.tsx`/`page/details.tsx` effect verbatim:
 * once `fetchTrackOrder` fails with a recognized API error code, redirect to
 * the matching error page. -400 = order not found, -403 = tracking link
 * expired. Shared by Home and Order Details — the only two pages that
 * trigger the initial fetch.
 */
export function useOrderErrorRedirect() {
  const navigate = useNavigate();
  const error = useSelector((state: RootState) => state.order.error);

  useEffect(() => {
    if (!error?.data) return;
    if (error.data.code === -400) navigate("/not-found");
    if (error.data.code === -403) navigate("/expire");
  }, [error, navigate]);
}
